module.exports = __webpack_public_path__ + "img/desk2.5667eec1.png";